import React from 'react';
import { Text, View, TouchableOpacity } from 'react-native';
import SmallClassImage from './SmallClassImage';
import SoundButton from './SoundButton';
import TribeImage from './TribeImage';
import TechLevelImage from './TechLevelImage';
import { battlegroundTribe, battlegroundTechLevel, getCardSounds } from './HelperFunctions'


const CardListItem = (props) => {

  const card = props.item
  const typeFilter = props.typeFilter
  const showCard = props.showCard

  let includeRowSounds = (card.type == 'MINION' && !['BGS_046t', 'BAR_919t'].includes(card.id)) && typeFilter == 'Cards'

  let cardSounds = []

  if (includeRowSounds) {
    cardSounds = getCardSounds(card).filter(sound => ['Play', 'Attack', 'Death'].includes(sound.name))
  }

  return (

    <TouchableOpacity onPress= {() => {showCard(card)}}>
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center'
      , justifyContent: 'space-between'
      , marginTop: 4, marginBottom: 4, marginRight: 8}}>
        { typeFilter == 'Battlegrounds' ?
            <>
              <TribeImage tribe={battlegroundTribe(card.id)}/>
              <TechLevelImage techlevel={battlegroundTechLevel(card)}/>
            </>
            : <SmallClassImage card={card}/>
        }

        <Text style={{flexGrow: 1}} >{card.name}</Text>
        {includeRowSounds ?
          <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            {cardSounds.map(sound => (
              <SoundButton title={sound.name} sound={sound.audio} listButton={true}/>
            ))} 
          </View>
          : <></>

      }
      </View>
    </TouchableOpacity>
  )
}

export default CardListItem
